import { render, staticRenderFns } from "./M2hDailyInspiration.vue?vue&type=template&id=bc4a8868&scoped=true&"
import script from "./M2hDailyInspiration.vue?vue&type=script&lang=js&"
export * from "./M2hDailyInspiration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc4a8868",
  null
  
)

export default component.exports